"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StoryUtil = void 0;
const is_blank_1 = __importDefault(require("@sedan-utils/is-blank"));
const StudioProjectAttributes_1 = require("../../project/domain/StudioProjectAttributes");
const StudioProjectAttributesV2UIInput_1 = require("../../project/domain/StudioProjectAttributesV2UIInput");
const StudioProjectAttributesV2UIOutput_1 = require("../../project/domain/StudioProjectAttributesV2UIOutput");
const Story_1 = require("./Story");
const StoryEdge_1 = require("./StoryEdge");
const StoryEdgeOptionsUtil_1 = require("./StoryEdgeOptionsUtil");
const StoryNode_1 = require("./StoryNode");
const StoryNodeOptionsUtil_1 = __importDefault(require("../../storyV2/domain/StoryNodeOptionsUtil"));
const StoryNodeType_1 = require("./StoryNodeType");
const StoryVariable_1 = require("./StoryVariable");
const StoryLine_1 = require("./StoryLine");
const StudioProjectAttributesV2Edge_1 = require("../../project/domain/StudioProjectAttributesV2Edge");
const StoryLineOptions_1 = require("./StoryLineOptions");
const StudioProjectAttributesV3NodeData_1 = require("../../project/domain/StudioProjectAttributesV3NodeData");
const ArrayUtil_1 = require("../../util/ArrayUtil");
const StoryNodeDisplayType_1 = require("../../storyV2/domain/StoryNodeDisplayType");
const SubStory_1 = require("../../storyV2/domain/SubStory");
class StoryUtil {
    static from(params, isFromUIData, nodeIndexRef) {
        // console.log("StudioProject :>>", params);
        this.publishIfNeeded(params);
        /// 根据Project数据构建所有的节点（Node）
        const nodes = (params.attributes?.v3?.nodes ?? []).filter(x => x.data instanceof StudioProjectAttributesV3NodeData_1.StudioProjectAttributesV3NodeData);
        const edges = (params.attributes?.v3?.nodes ?? []).filter(x => x.data instanceof StudioProjectAttributesV2Edge_1.StudioProjectAttributesV2EdgeData);
        const storyNodes = nodes
            .map(node => {
            return StoryNodeOptionsUtil_1.default.from(node, isFromUIData);
        })
            .map(options => {
            let node = new StoryNode_1.StoryNode(options);
            node.content = options.content ?? "";
            return node;
        });
        const variables = (params.attributes?.v3?.variablesList ?? []).map(variable => {
            return new StoryVariable_1.StoryVariable(variable.name, variable.node?.data?.textAreaValue || "", variable.node?.id || "");
        });
        /// 根据Project数据构建所有的边（Edge）
        const storyEdges = edges
            .map(x => StoryEdgeOptionsUtil_1.StoryEdgeOptionsUtil.from(x))
            .map(options => {
            const edge = new StoryEdge_1.StoryEdge(options);
            return edge;
        });
        const lines = params.attributes?.v3?.edges ?? [];
        lines.forEach((line, index) => {
            let source = storyNodes.find(x => x.options.id === line.source);
            let target = storyEdges.find(x => x.options.id === line.target);
            if (source !== undefined && target !== undefined) {
                source.lines.push(new StoryLine_1.StoryInputLine(new StoryLineOptions_1.StoryLineOptions(line.id), source.options.id, target));
            }
            source = storyEdges.find(x => x.options.id === line.source);
            target = storyNodes.find(x => x.options.id === line.target);
            if (source !== undefined && target !== undefined) {
                source.target = new StoryLine_1.StoryOutputLine(new StoryLineOptions_1.StoryLineOptions(line.id), source.options.id, target);
            }
        });
        storyNodes.forEach(node => {
            /// 查找子节点
            node.children = StoryUtil.findChildrenNode(node, storyNodes);
        });
        const inputId = (params.attributes?.v3?.UI ?? [])
            .flatMap(x => {
            if (x.input instanceof StudioProjectAttributesV2UIInput_1.StudioProjectAttributesV2UIInput) {
                return [x.input.id];
            }
            if (StoryUtil.isStudioProjectAttributesV2UIInputArray(x.input)) {
                const inputs = x.input;
                return inputs.map(x => x.id);
            }
            return [""];
        })
            .filter(x => !(0, is_blank_1.default)(x));
        /// 根据 UI 节点查找 input 节点，并组装 Idea
        const startNodes = StoryUtil.findStartNodes(storyNodes, storyEdges, inputId);
        // single edges
        const singleEdges = storyEdges.filter(x => x.target === undefined);
        /// 生成 Story 返回
        return new Story_1.Story(params.attrIndexer ?? "", startNodes, singleEdges, variables, params.id ?? "", nodeIndexRef);
    }
    /// 查找子节点
    static findChildrenNode(node, nodes) {
        return nodes.filter(x => node.options.children.includes(x.options.id));
    }
    /// 根据 UI 节点查找 StoryUtil input 节点，并组装 Idea
    static findStartNodes(nodes, edges, inputId) {
        /// 所有边对应的 target
        const targets = edges.map(x => x.targetNode()?.options.id);
        const startNodes = nodes.filter(x => {
            return (0, is_blank_1.default)(x.options.parentId) && !targets.includes(x.options.id);
        });
        /// 判断是否为 input 节点
        startNodes.forEach(node => {
            node.isInput = inputId.includes(node.options.id);
        });
        return startNodes;
    }
    static isStudioProjectAttributesV2UIInputArray(array) {
        return array.every(item => item instanceof StudioProjectAttributesV2UIInput_1.StudioProjectAttributesV2UIInput);
    }
    /// create mock data when inputs and outputs are all empty
    static publishIfNeeded(project) {
        let inputs = project.attributes?.v3?.UI?.first()?.input;
        let outputs = project.attributes?.v3?.UI?.first()?.output;
        if ((0, is_blank_1.default)(inputs) && (0, is_blank_1.default)(outputs)) {
            let attributesV3UI = project.attributes?.v3?.UI?.first() ?? new StudioProjectAttributes_1.StudioProjectAttributesV2UI();
            const nodes = (project.attributes?.v3?.nodes ?? [])
                .filter(x => x.data instanceof StudioProjectAttributesV3NodeData_1.StudioProjectAttributesV3NodeData)
                .map(node => {
                return StoryNodeOptionsUtil_1.default.from(node);
            })
                .map(options => {
                let node = new StoryNode_1.StoryNode(options);
                node.content = options.content ?? "";
                return node;
            });
            const edges = (project.attributes?.v3?.nodes ?? [])
                .filter(x => x.data instanceof StudioProjectAttributesV2Edge_1.StudioProjectAttributesV2EdgeData)
                .map(x => StoryEdgeOptionsUtil_1.StoryEdgeOptionsUtil.from(x))
                .map(options => {
                const edge = new StoryEdge_1.StoryEdge(options);
                return edge;
            });
            const lines = project.attributes?.v3?.edges ?? [];
            lines.forEach((line, index) => {
                const source = edges.find(x => x.options.id === line.source);
                const target = nodes.find(x => x.options.id === line.target);
                if (source !== undefined && target !== undefined) {
                    source.target = new StoryLine_1.StoryOutputLine(new StoryLineOptions_1.StoryLineOptions(line.id), source.options.id, target);
                }
            });
            // use start nodes fill inputs
            const targets = edges.map(x => x.targetNode()?.options.id);
            const startNodes = nodes.filter(x => {
                return (0, is_blank_1.default)(x.options.parentId) && !targets.includes(x.options.id);
            });
            attributesV3UI.input = startNodes.map(node => {
                let input = new StudioProjectAttributesV2UIInput_1.StudioProjectAttributesV2UIInput();
                input.id = node.options.id;
                let data = new StudioProjectAttributesV2UIInput_1.StudioProjectAttributesV2UIInputData();
                data.displayType = node.options.displayType;
                input.data = data;
                return input;
            });
            // use the others fill outputs
            const otherNodes = nodes.filter(x => !startNodes.includes(x));
            attributesV3UI.output = otherNodes.map(node => {
                let output = new StudioProjectAttributesV2UIOutput_1.StudioProjectAttributesV2UIOutput();
                if (node.options.type === StoryNodeType_1.StoryNodeType.CUSTOMGROUP) {
                    output.groupId = node.options.id;
                }
                else if (node.options.type === StoryNodeType_1.StoryNodeType.CUSTOMNODE) {
                    let result = new StudioProjectAttributesV2UIOutput_1.StudioProjectAttributesV2UIOutputResults();
                    result.nodeId = node.options.id;
                    output.results = [result];
                }
                return output;
            });
            if (project.attributes?.v3?.UI?.length === 0) {
                project.attributes?.v3?.UI?.push(attributesV3UI);
            }
        }
    }
    /// 项目是否是多输入框
    static multiInput(story) {
        const allNodes = story.findAllNodes();
        const inputNodes = allNodes.filter(node => node.isInput);
        return inputNodes.length > 1;
    }
    /// 多输入框时，输入框对应的各自的变量名
    static multiInputVariables(story) {
        const allNodes = story.findAllNodes();
        const inputNodes = allNodes.filter(node => node.isInput);
        const variableNames = inputNodes
            .map(value => {
            if (!(0, is_blank_1.default)(value.options.inputTitle)) {
                return value.options.inputTitle;
            }
            for (const element of story.variableList) {
                if (element.nodeId === value.options.id) {
                    return element.name;
                }
            }
            return "";
        })
            .filter(e => e !== "");
        return variableNames;
    }
    static findEdgeSoures(story, edge) {
        const allNodes = story.findAllNodes();
        const sourceNodes = [];
        for (const node of allNodes) {
            if (StoryUtil.containEdge(node.edges(), edge)) {
                sourceNodes.push(node);
            }
        }
        return sourceNodes;
    }
    static findEdgeSoure(story, edge) {
        const sources = StoryUtil.findEdgeSoures(story, edge);
        return sources.first();
    }
    static findNodeSource(story, node) {
        const allEdges = story.findAllEdges();
        for (const e of allEdges) {
            if (e.targetNode()?.options.id === node.options.id) {
                return e;
            }
        }
        return undefined;
    }
    static containEdge(edges, edge) {
        for (const edgeInArr of edges) {
            if (edgeInArr.options.id === edge.options.id) {
                return true;
            }
        }
        return false;
    }
    static findSourceQuerys(story, edge) {
        const sourceNodes = this.findEdgeSoures(story, edge);
        return sourceNodes.reduce((inputs, node) => {
            const { options, content } = node;
            const { displayType, generatedLabel, inputTitle } = options;
            const name = generatedLabel || inputTitle || "input";
            return inputs.concat({
                name,
                value: content,
                type: displayType || StoryNodeDisplayType_1.StoryNodeDisplayType.TEXT,
            });
        }, []);
    }
    static findNode(variableName, story) {
        const variable = story.variableList.filter(e => e.name === variableName);
        const node = story.findNodesById(variable.first()?.nodeId || "");
        return node;
    }
    static findNodeSourceNode(story, node) {
        const allNodes = story.findAllNodes();
        return allNodes.filter(n => {
            const targetNodes = n
                .edges()
                .map(e => e.targetNode())
                .filter(n => n !== undefined);
            if (ArrayUtil_1.ArrayUtil.contains(targetNodes, node, element => element.options.id)) {
                return true;
            }
            return false;
        });
    }
    static findParent(story, node) {
        const nodes = story.findAllNodes();
        const targetGroups = nodes.filter(x => x.childIds().includes(node.id));
        return targetGroups;
    }
    /// 反查传入的imgNode的前一个node
    static findImgNodeDataSource(story, node) {
        if (node.options.displayType !== StoryNodeDisplayType_1.StoryNodeDisplayType.IMAGESEARCH &&
            node.options.displayType !== StoryNodeDisplayType_1.StoryNodeDisplayType.IMAGEGEN) {
            /// throw error
            return undefined;
        }
        const allNodes = story.findAllNodes();
        const groupNode = allNodes
            .filter(n => {
            return ArrayUtil_1.ArrayUtil.contains(n.children, node, element => element.options.id);
        })
            .first();
        if (!groupNode) {
            return StoryUtil.findNodeSourceNode(story, node).first();
        }
        let indexInGroup = 0;
        groupNode.children.forEach((value, index, array) => {
            if (value.options.id === node.options.id) {
                indexInGroup = index;
            }
        });
        const sourceGroupNode = StoryUtil.findNodeSourceNode(story, groupNode).first();
        if (!sourceGroupNode) {
            return undefined;
        }
        return sourceGroupNode.children.get(indexInGroup);
    }
    static edgesNoRelateInput(story) {
        function nodeEdges(node, originalEdges) {
            if (node.allEdges().length === 0) {
                return originalEdges;
            }
            let newArr = [...originalEdges, ...node.allEdges()];
            const nextNodes = node
                .allEdges()
                .map(e => e.targetNode())
                .filter(n => n !== undefined);
            if (nextNodes.length === 0) {
                return newArr;
            }
            nextNodes.forEach(n => {
                newArr = [...newArr, ...nodeEdges(n, newArr)];
            });
            return newArr;
        }
        let edges = [];
        story.startNodes.forEach(node => {
            if (!node.isInput) {
                edges = [...edges, ...nodeEdges(node, [])];
            }
        });
        return edges;
    }
    /**
     * 获取最后一个节点
     * @param story
     */
    static getNoTargetNodes(story) {
        // 没有target的node，那么就是最后一个node
        // TODO: allNodes 查询的时候发现会找到childNode并且没有parentId
        const allEdges = story.findAllEdges();
        const noTargetNodes = allEdges
            .filter(x => {
            const haveTarget = x.targetNode()?.lines.some(line => line.target !== undefined);
            return !haveTarget;
        })
            .map(edge => {
            return edge.targetNode();
        });
        if (noTargetNodes.length > 0) {
            return noTargetNodes[0];
        }
        return undefined;
    }
    static updateGraphData(story, sourceNodes) {
        if (story instanceof SubStory_1.SubStory) {
            return;
        }
        const nodes = story.graphData?.v3?.nodes;
        if (!nodes) {
            return;
        }
        sourceNodes.forEach(sourceNode => {
            sourceNode.children.forEach(childNode => {
                this.replaceGraphDataTextAreaValue(childNode, nodes);
            });
            this.replaceGraphDataTextAreaValue(sourceNode, nodes);
        });
    }
    static replaceGraphDataTextAreaValue(sourceNode, graphDataNodes) {
        const node = graphDataNodes.filter(node => node.id === sourceNode.id).first();
        if (node && node.data) {
            node.data.textAreaValue = sourceNode.originContent ? sourceNode.originContent : sourceNode.content;
        }
    }
}
exports.StoryUtil = StoryUtil;
